import React, { PropTypes } from 'react';
import { NitroHeading, NitroPlaceholder, NitroParagraph } from 'nitro-components';

import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

const VehicleText = ({ makeModel, makeName, modelName, year, bodyType, driveType, transmission, fuelType, horizontal , headingVariant}) => {
  const label = makeModel ? `${makeModel}` : `${makeName} ${modelName}`;
  return (
    <Wrapper horizontal={horizontal}>
      <NitroHeading label={label} size="3" variant={headingVariant || ''} noMargin align="center" />
      <NitroPlaceholder size={8} />
      <NitroParagraph align="center" variant="secondary" noMargin>{year} {bodyType} {driveType}</NitroParagraph>
      <NitroParagraph align="center" variant="secondary" noMargin>{transmission}</NitroParagraph>
      <NitroParagraph align="center" variant="secondary" noMargin>{fuelType}</NitroParagraph>
    </Wrapper>
  );
};

VehicleText.propTypes = {
  makeModel: PropTypes.string,
  makeName: PropTypes.string,
  modelName: PropTypes.string,
  year: PropTypes.string,
  bodyType: PropTypes.string,
  driveType: PropTypes.string,
  transmission: PropTypes.string,
  fuelType: PropTypes.string,
  horizontal: PropTypes.bool,
  headingVariant: PropTypes.string
};

export default VehicleText;



// WEBPACK FOOTER //
// ./src/components/vehicle/VehicleText.js